import { createContext, useContext } from 'react';

export type FormFieldContextValue = {
  inFormField: boolean;
  error?: string;
  fieldId?: string;
};

export const FormFieldContext = createContext<FormFieldContextValue>({
  inFormField: false,
});

export function useFormFieldContext(): FormFieldContextValue {
  return useContext(FormFieldContext);
}
